
import { TabViewModel } from '../../models/common/tab-view.model';
import { ITabViewState } from './tab-view-types.store';

export class TabViewState implements ITabViewState {
    tabViews: Array<TabViewModel>;
    activeTab: TabViewModel;
    oldTab: TabViewModel;
    constructor() {
        this.tabViews = []; // toto: init cached tab views
        this.activeTab = null;
        this.oldTab = null;
    }
}

